export enum NetworkName {
  BITCOIN = 'BITCOIN',
  BITCOIN_CASH = 'BITCOIN_CASH',
  BITCOIN_CASH_TESTNET = 'BITCOIN_CASH_TESTNET',
  BITCOIN_TESTNET = 'BITCOIN_TESTNET',
  BNB = 'BNB',
  BNB_TESTNET = 'BNB_TESTNET',
  DOGECOIN = 'DOGECOIN',
  DOGECOIN_TESTNET = 'DOGECOIN_TESTNET',
  ELROND = 'ELROND',
  ELROND_TESTNET = 'ELROND_TESTNET',
  ETHEREUM = 'ETHEREUM',
  ETHEREUM_TESTNET = 'ETHEREUM_TESTNET',
  KUJI = 'KUJI',
  KUJI_TESTNET = 'KUJI_TESTNET',
  LITECOIN = 'LITECOIN',
  LITECOIN_TESTNET = 'LITECOIN_TESTNET',
  POLYGON = 'POLYGON',
  POLYGON_TESTNET = 'POLYGON_TESTNET',
  ARBITRUM = 'ARBITRUM',
  ARBITRUM_TESTNET = 'ARBITRUM_TESTNET',
  DEVNET_L1A = 'DEVNET_L1A',
  DEVNET_L1B = 'DEVNET_L1B',
  TRON = 'TRON',
  TRON_TESTNET = 'TRON_TESTNET',
  SOLANA = 'SOLANA',
  SOLANA_TESTNET = 'SOLANA_TESTNET',
  BASE = 'BASE',
  BASE_TESTNET = 'BASE_TESTNET',
}
